/**
 * How the site presents a discounted price. Set site-wide in Contentstack by the
 * E-commerce team, so a trading period can be presented as a sale or as an offer
 * without a release. It changes the treatment only: a discounted product shows its
 * saving either way.
 */
export type DiscountPresentationMode = 'offer' | 'sale';

export const DEFAULT_DISCOUNT_PRESENTATION_MODE: DiscountPresentationMode = 'offer';

/**
 * Contentstack hands the mode over as free text, so it is narrowed once here rather
 * than at every read.
 *
 * Anything unrecognised falls back to 'offer', the understated treatment, so a typo
 * or an unreachable stack never announces a sale that may not be running.
 */
export const toDiscountPresentationMode = (value: unknown): DiscountPresentationMode =>
  value === 'sale' ? 'sale' : DEFAULT_DISCOUNT_PRESENTATION_MODE;
